// extracted by mini-css-extract-plugin
export default {"search":"style_search__sN+m-","form":"style_form__i1vge"};